import * as tslib_1 from "tslib";
/* I125 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var CommentOutline = function (props) {
    return (React.createElement(IconWrap, tslib_1.__assign({}, props),
        React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", null,
                React.createElement("path", { d: "M11.2559524,22 L8.58482143,17.8190802 L2,17.8190802 L2,6.21892816 L6.12202381,2 L22,2 L22,13.6077537 L17.8854167,17.8190802 L13.9270833,17.8190802 L11.2559524,22 Z M3.42857143,16.2206849 L9.37012987,16.2206849 L11.2507493,19.1428571 L13.1313686,16.2206849 L17.3046953,16.2206849 L20.5714286,12.895192 L20.5714286,3.42857143 L6.7027972,3.42857143 L3.42857143,6.75406434 L3.42857143,16.2206849 Z" })))));
};
CommentOutline.displayName = 'CommentOutline';
export default CommentOutline;
//# sourceMappingURL=CommentOutline.js.map